import React, { useState, useEffect } from 'react'
import { useGeolocation } from 'react-use'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from '@/components/ui-compat'
import { useTranslation } from 'react-i18next'
import { MapPin } from 'lucide-react'

import LocationPicker from 'react-location-picker'

// Fallback when geolocation is unavailable
const DEFAULT_LAT = 50.0755  // Prague
const DEFAULT_LNG = 14.4378

const PlaceSelect = ({ onChange, defaultChosenPosition, addrText, readOnly = false }) => {
  const { t } = useTranslation()

  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  const [positionSelected, setPositionSelected] = useState(false)
  const [automaticPositionInitialized, setAutomaticPositionInitialized] = useState(false)
  const [automaticPositionLoaded, setAutomaticPositionLoaded] = useState(false)

  const automaticPosition = useGeolocation()

  const getCoords = (geo) => ({
    latitude: geo.latitude && geo.latitude !== 0 ? geo.latitude : DEFAULT_LAT,
    longitude: geo.longitude && geo.longitude !== 0 ? geo.longitude : DEFAULT_LNG,
  })

  const [position, setPosition] = useState(() => {
    const { latitude, longitude } = getCoords(automaticPosition)

    return defaultChosenPosition.longitude === null && defaultChosenPosition.latitude === null
      ? {
          address: defaultChosenPosition.address === null ? null : defaultChosenPosition.address,
          lat: latitude,
          lng: longitude,
        }
      : { ...defaultChosenPosition }
  })

  useEffect(() => {
    if (!automaticPosition.loading && !automaticPositionInitialized) {
      setAutomaticPositionInitialized(true)
    }
  }, [automaticPosition.loading])

  useEffect(() => {
    let coords = getCoords(automaticPositionInitialized && !automaticPositionLoaded ? automaticPosition : { latitude: null, longitude: null })
    if (automaticPositionInitialized && !automaticPositionLoaded) {
      setAutomaticPositionLoaded(true)
    }

    let pos =
      defaultChosenPosition.longitude === null && defaultChosenPosition.latitude === null
        ? {
            address: defaultChosenPosition.address === null ? null : defaultChosenPosition.address,
            lat: coords.latitude,
            lng: coords.longitude,
          }
        : { ...defaultChosenPosition }

    setPosition(pos)
  }, [defaultChosenPosition, automaticPositionInitialized])

  const handleLocationChange = (loc) => {
    let newPosition = loc.position
    newPosition.address = loc.address

    setPosition(newPosition)
    setPositionSelected(true)
  }

  const onSelectBtnClick = () => {
    toggle()
    setPositionSelected(false)
    onChange(position)
  }

  return (
    <>
      <Button disabled={readOnly} onClick={!readOnly && toggle} style={{ zIndex: '0 !important' }}>
        <MapPin className="h-4 w-4" />
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{position.address}</ModalHeader>
        <ModalBody>
          <LocationPicker
            containerElement={<div style={{ height: '100%' }} />}
            mapElement={<div style={{ height: '400px' }} />}
            defaultPosition={position}
            onChange={handleLocationChange}
            radius={-1}
          />
        </ModalBody>
        <ModalFooter>
          <Button disabled={!positionSelected} onClick={onSelectBtnClick}>
            {t('Place_select_modal_confirm_place_btn')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default PlaceSelect
